import './style.scss';

const ApiRequestPreloader = () => (
    <div className="request-preloader">
        <div className="loader" />
    </div>
);

export default ApiRequestPreloader;
